import { Product } from './product'

export enum ProductVariantsDisplay {
  Default = 'default',
  ColourSwatch = 'colour-swatch',
}

export type ProductVariantOptionText = {
  title: string
  url: string
  selected: boolean
}

export type ProductVariantOptionColor = {
  title: string
  url: string
  color: ProductVariantOptionColorValue
  selected: boolean
}

export type ProductVariantOptionColorValue = {
  hex: string
}

export type ProductVariantOptionGroupColor = {
  title: string
  type: 'color'
  values: ProductVariantOptionColor[]
}

export type ProductVariantOptionGroupText = {
  title: string
  type: 'text'
  values: ProductVariantOptionText[]
}

export type ProductVariantOptionComplex = Pick<
  Product,
  'title' | 'url' | 'thumbnail' | 'finalPrice' | 'regularPrice' | 'attributes'
> & {
  selected: boolean
  inStock?: boolean
}

export type ProductVariantOption = Pick<
  Product,
  'title' | 'url' | 'thumbnail' | 'finalPrice' | 'regularPrice' | 'attributes' | 'sku'
> & {
  selected: boolean
  /*
   * Whether the variant can be had at all - by delivery or from the selected
   * store. Undefined for lists that carry no stock data, such as spare parts.
   */
  inStock?: boolean
}

export type ProductVariantOptionGroupSimpleProps = ProductVariantOptionGroupText | ProductVariantOptionGroupColor

export type ProductVariantOptionGroupComplexProps = {
  title: string
  type: 'complex'
  values: ProductVariantOptionComplex[]
}
